import { render, staticRenderFns } from "./cardDetail.vue?vue&type=template&id=b5878a4c&scoped=true&"
import script from "./cardDetail.vue?vue&type=script&lang=js&"
export * from "./cardDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardDetail.vue?vue&type=style&index=0&id=b5878a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5878a4c",
  null
  
)

export default component.exports